import { BASE_URL, DO_NOT_ORDER_LIST_ENDPOINT, SOMS_API_KEY } from "services/CONSTANTS";
import { REMOVE_DNO_ITEMS_FAILURE, REMOVE_DNO_ITEMS_REQUEST, REMOVE_DNO_ITEMS_RESET, REMOVE_DNO_ITEMS_SUCCESS } from "./action-type"
import { Patch } from "services/apiService";

export const removeDoNotOrderItemsAction = (payload) => {
    return (dispatch) => {
        dispatch(removeDoNotOrderItemsRequest());
        let apiUrl = `${BASE_URL}${DO_NOT_ORDER_LIST_ENDPOINT}?apikey=${SOMS_API_KEY}`;
        const request = {
            url: apiUrl,
            params: payload
        };
        Patch(request)
            .then((response) => {
                if (response.status === 200) {
                    dispatch(removeDoNotOrderItemsSuccess(response));
                } else {
                    dispatch(removeDoNotOrderItemsFailure(response));
                }
            })
            .catch((err) => {
                dispatch(removeDoNotOrderItemsFailure(err));
            });
    }
}

const removeDoNotOrderItemsRequest = () => {
    return {
        type: REMOVE_DNO_ITEMS_REQUEST
    }
}

const removeDoNotOrderItemsSuccess = (response) => {
    return {
        type: REMOVE_DNO_ITEMS_SUCCESS,
        removeDNOResponse: response
    }
}

const removeDoNotOrderItemsFailure = (error) => {
    return {
        type: REMOVE_DNO_ITEMS_FAILURE,
        removeDNOResponse: error
    }
}

export const removeDoNotOrderItemsReset = () => {
    return {
        type: REMOVE_DNO_ITEMS_RESET
    }
}